import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';

@Component({
    selector: 'app-pop-up-notification',
    templateUrl: './pop-up-notification.component.html',
    styleUrls: ['./pop-up-notification.component.scss'],
    standalone: false
})
export class PopUpNotificationComponent {
    @Input() message: string;
    @Input() closeButton: string;
    @Input() hideTimeout: number = 3000;

    @ViewChild('notificationContainer') notificationContainer: ElementRef;
    visible: boolean = false;

    constructor() {}

    clickOut(event: any) {
        if (this.visible && !this.notificationContainer.nativeElement.contains(event.target)) {
            this.closeNotification();
        }
    }

    setVisible(visible: boolean) {
        this.visible = visible;

        if (visible && this.hideTimeout) {
            setTimeout(() => {
                this.closeNotification();
            }, this.hideTimeout);
        }
    }

    closeNotification() {
        this.visible = false;
    }

    public getVisible() {
        return this.visible;
    }
}
